import { axiosPost } from '@/api/handlers';
import { useMutation } from '@/api/hooks';
import type { z } from 'zod';

import {
  OneTimeCodeKeyModel,
  RequestOneTimeCodeFormSchema,
  RequestResetPasswordSchema,
} from '../_models/reset-password';

export const useRequestOneTimeCode = () => {
  return useMutation({
    mutationFn: async (
      values: z.infer<typeof RequestOneTimeCodeFormSchema>,
    ) => {
      const payload = RequestOneTimeCodeFormSchema.parse(values);
      const res = await axiosPost(
        '/api/users/password-reset/request/',
        payload,
      );

      return OneTimeCodeKeyModel.parse(res);
    },
  });
};

export const useRequestResetPassword = () => {
  return useMutation({
    mutationFn: async (values: z.infer<typeof RequestResetPasswordSchema>) => {
      const payload = RequestResetPasswordSchema.parse(values);
      return await axiosPost('/api/users/password-reset/complete/', payload);
    },
  });
};
